import {
  type FC,
  type ReactNode,
  useCallback,
  useEffect,
  useState,
} from 'react';
import Headroom from 'react-headroom';

import {
  topSectionHeight,
  mobileHeaderHeight,
} from 'src/components/layouts/theme';

import getScrollPosition from '../../../utils/getScrollPosition';

export const MOBILE_NAVIGATION_SELECTOR = '#employer-header-mobile-navigation';

interface MobileStickyHeaderProps {
  employerHeader: ReactNode;
  pageTabs: ReactNode;
  mobileFilterSection: ReactNode;
}

export const MobileStickyHeader: FC<MobileStickyHeaderProps> = ({
  employerHeader,
  pageTabs,
  mobileFilterSection,
}) => {
  const [isAtTopOfPage, setIsAtTopOfPage] = useState(true);

  useEffect(() => {
    const updateEmployerHeaderMobileNavigationHeight = () => {
      const employerHeaderMobileNavigation = document.querySelector(
        MOBILE_NAVIGATION_SELECTOR,
      ) as HTMLElement;
      if (employerHeaderMobileNavigation) {
        employerHeaderMobileNavigation.style.height = `${
          window.innerHeight - mobileHeaderHeight
        }px`;
      }
    };

    updateEmployerHeaderMobileNavigationHeight();

    window.addEventListener(
      'resize',
      updateEmployerHeaderMobileNavigationHeight,
    );
    return function cleanup() {
      window.removeEventListener(
        'resize',
        updateEmployerHeaderMobileNavigationHeight,
      );
    };
  }, []);

  const onStickyTopChanged = useCallback(() => {
    const shouldHide = getScrollPosition() <= topSectionHeight;
    setIsAtTopOfPage(shouldHide);
  }, [setIsAtTopOfPage]);

  useEffect(() => {
    onStickyTopChanged();
    window.addEventListener('scroll', onStickyTopChanged);
    return function cleanup() {
      window.removeEventListener('scroll', onStickyTopChanged);
    };
  }, [onStickyTopChanged]);

  return isAtTopOfPage ? null : (
    <Headroom
      pinStart={topSectionHeight}
      wrapperStyle={{ position: 'relative', zIndex: 200 }}
    >
      {employerHeader}
      {pageTabs}
      {mobileFilterSection}
    </Headroom>
  );
};
